import { axiosInstance } from ".."

const partnerDetails = async (id) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/customers/partnerDetails?user_id=${id}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default partnerDetails;